import type { MakeCall } from '../createMakeCall';
import { Money } from '../types/common';
import { PayInMethod, PayInResource } from './types';

export type Payload = {
  payinMethodType?: PayInMethod; // use only when you don't have uuid
  payinMethodUuid?: string; // use when you have uuid
  settlementReference: string;
  value: Money;
};

export type Response = PayInResource;

const createPayIn = (makeCall: MakeCall) => (data: Payload) =>
  makeCall<Response>('POST', `/api/v2/payment/pay-in`, { data });
export { createPayIn };
